import { createRoot } from 'react-dom/client';
import { AppProviders } from '@/providers/AppProviders';
import App from './components/App';
import './sass/global.scss';

const rootBtn = document.getElementById('creator-root')!;
const root = createRoot(rootBtn);

root.render(
	<AppProviders>
		<App />
	</AppProviders>
);
